module.exports = __webpack_public_path__ + "assets/img/banner.970ebe82.jpg";